module.exports = __webpack_public_path__ + "img/logo.5af8156e.png";